import * as React from 'react';

import { useNavigation } from 'hooks/navigation/use-navigation';
import useEffectOnUnmount from 'hooks/use-effect-on-unmount';
import { useAuthContext } from 'state/auth';
import { useLoyaltyClaimPointsContext } from 'state/loyalty-claim-points';
import { routes } from 'utils/routing';

import LoyaltyClaimPointsView from './loyalty-claim-points.view';

const LoyaltyClaimPointsHome = () => {
  const { data } = useLoyaltyClaimPointsContext();
  const { navigate } = useNavigation();
  const { isAuthenticated, closeModalAuth, openSignInModal } = useAuthContext();

  const handleOnPress = (path?: string | null) => {
    if (!isAuthenticated) {
      return openSignInModal();
    }
    navigate(path || routes.base);
  };

  // Close auth modal when leaving page
  useEffectOnUnmount(() => {
    closeModalAuth();
  });

  const content = data?.claimPointsHomeScreenContent;

  return <LoyaltyClaimPointsView content={content} onPress={handleOnPress} />;
};

export default LoyaltyClaimPointsHome;
